// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-upload .k-upload-files {
  display: none !important;
}

.k-action-buttons {
  display: none !important;
}

.k-clear-selected, .k-upload-selected {
  display: none !important;
}

.attachment-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/invoices/attachments/invoice-attachments.component.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;AACJ;;AACA;EACI,wBAAA;AAEJ;;AACA;EACI,wBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAEJ","sourcesContent":[".k-upload .k-upload-files {\n    display: none !important;\n}\n.k-action-buttons {\n    display: none !important;\n\n}\n.k-clear-selected, .k-upload-selected {\n    display: none !important;\n}\n\n.attachment-actions {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
